import { is } from "ramda";

export default stringOrArray =>
  is(String, stringOrArray) ? [stringOrArray] : stringOrArray;
